import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="bg-[#e9f6e8] ">
      <h1 className="xl:text-6xl lg:text-5xl text-4xl font-lexend pt-36 lg:pb-28 md:pb-20 pb-14 font-extralight text-center text-[#3a683f]">
        FAQs
      </h1>
      <div className="w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[88rem] 2xl:px-0 xl:px-8 md:px-0 px-6  xs:px-4 mx-auto">
        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(1)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              1
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:md:font-semibold  font-medium font-lexend">
                What is so different about Moondew?
              </span>
              <span className="text-2xl">
                {openIndex === 1 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 1
                ? "2xl:max-h-60 max-h-96 opacity-100"
                : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew is built around the belief that better sleep begins with
                better materials, thoughtful design, and personalized comfort.
                Unlike conventional mattress brands, Moondew combines certified
                materials, in-house manufacturing expertise, premium
                craftsmanship, and customization to create mattresses tailored
                to individual sleep needs.
              </p>
              <p className="mt-1.5">Our approach focuses on:</p>
              <ul className="list-disc ps-6 pt-1">
                <li>Certified and carefully sourced materials</li>
                <li>Personalized sleep solutions</li>
                <li>Premium comfort engineering</li>
                <li>Sustainable practices</li>
                <li>Controlled manufacturing and quality assurance</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(2)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              2
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                Where are Moondew products manufactured?
              </span>
              <span className="text-2xl">
                {openIndex === 2 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 2 ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew products are manufactured near Hyderabad, Telangana,
                India. Our production combines advanced manufacturing processes,
                carefully selected raw materials, and rigorous quality control
                systems to maintain premium standards.
              </p>
            </div>
          </div>
        </div>
        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(3)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              3
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                Who are the promoters of Moondew?
              </span>
              <span className="text-2xl">
                {openIndex === 3 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 3 ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew is promoted by{" "}
                <span className="md:font-semibold font-medium">
                  Dr. Vijay Kumar Prodduturi (MBBS)
                </span>{" "}
                and{" "}
                <span className="md:font-semibold font-medium">
                  Mr. Vikram Chandra Prodduturi
                </span>
                , bringing together healthcare understanding, global exposure,
                and a vision to elevate sleep experiences in India.
              </p>
            </div>
          </div>
        </div>
        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(4)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              4
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                What is the vision with which Moondew was founded?
              </span>
              <span className="text-2xl">
                {openIndex === 4 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 4 ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew was founded with the vision of creating sleep solutions
                that combine comfort, health, and sustainability. Built on years
                of manufacturing expertise and a commitment to innovation, the
                brand was created to bridge the gap between premium global sleep
                experiences and the evolving expectations of Indian
                consumers.{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(5)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              5
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                Why are the prices of Moondew products higher than those of
                other brands?
              </span>
              <span className="text-2xl">
                {openIndex === 5 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 5 ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew products are crafted using premium materials, certified
                components, advanced manufacturing methods, and carefully
                engineered comfort systems. While positioned above conventional
                mattresses, they remain competitive compared to premium
                international brands and are designed to deliver long-term value
                and better sleep experiences.
              </p>
            </div>
          </div>
        </div>

        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(6)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              6
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                Where does Moondew procure its raw materials from?
              </span>
              <span className="text-2xl">
                {openIndex === 6 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 6
                ? "md:max-h-60 max-h-96 opacity-100"
                : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew follows a rigorous sourcing process by partnering with
                trusted suppliers and selecting materials based on quality and
                certification standards.
              </p>
              <ul className="list-disc ps-6 pt-1">
                <li>
                  Certified latex is sourced from Sri Lanka to meet organic
                  certification requirements
                </li>
                <li>
                  Additional materials, such as coir and specialty fabrics, are
                  sourced from selected partners
                </li>
                <li>
                  Premium fabrics are selected for comfort, durability, and
                  aesthetics.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(7)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              7
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                Are all products sold by Moondew manufactured by Moondew?
              </span>
              <span className="text-2xl">
                {openIndex === 7 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 7 ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Yes. All Moondew products are manufactured in-house, allowing
                complete control over design, material selection, quality
                assurance, and innovation.
              </p>
            </div>
          </div>
        </div>

        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(8)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              8
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                What are the latex specifications and sourcing details for
                Moondew products?
              </span>
              <span className="text-2xl">
                {openIndex === 8 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 8
                ? "md:max-h-60 max-h-96 opacity-100"
                : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew’s Organiq collection uses{" "}
                <span className="font-bold">certified organic latex</span>{" "}
                selected to deliver{" "}
                <span className="font-bold">
                  natural comfort, durability, breathability, and premium
                </span>{" "}
                sleep performance while meeting strict quality standards. The
                latex is{" "}
                <span className="font-bold">procured from Sri Lanka</span> to
                align with international organic certification requirements.
              </p>
              <p className="mt-1">
                Moondew prioritizes{" "}
                <span className="font-bold">
                  certified and carefully sourced materials
                </span>{" "}
                to create a cleaner and healthier sleep environment. The Organiq
                collection focuses on{" "}
                <span className="font-bold">
                  organic latex solutions designed to offer a natural,
                  comfortable, and premium sleep experience.
                </span>{" "}
              </p>
            </div>
          </div>
        </div>

        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(9)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              9
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                What certifications do Moondew products have?
              </span>
              <span className="text-2xl">
                {openIndex === 9 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 9 ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew uses certified materials across selected collections,
                including:
              </p>
              <ul className="list-disc ps-6 pt-1">
                <li>GOTS (Global Organic Textile Standard)</li>
                <li>GOLS (Global Organic Latex Standard)</li>
              </ul>
              <p className="pt-1">
                These certifications reinforce Moondew’s commitment to
                authenticity, quality, and sustainability.
              </p>
            </div>
          </div>
        </div>
        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(10)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              10
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                Which Moondew mattress is best suited for my sleep position,
                comfort preferences, age group, and support requirements?
              </span>
              <span className="text-2xl">
                {openIndex === 10 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 10
                ? "xl:max-h-96  opacity-100"
                : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew offers a wide range of mattresses designed to support
                different{" "}
                <span className="font-bold">
                  sleep positions, comfort preferences, age groups, and support
                  needs.
                </span>{" "}
                Recommendations can be customized based on individual
                requirements to help find the most suitable comfort and support
                combination.
              </p>
              <ul className="list-disc ps-6 pt-1">
                <li>
                  {" "}
                  <span className="font-bold">
                    For people with back pain:
                  </span>{" "}
                  Orthopedic-focused mattresses using combinations of{" "}
                  <span className="font-bold">
                    Latex, HR Foam, RBF, and advanced support technologies
                  </span>{" "}
                  may be recommended.
                </li>
                <li>
                  {" "}
                  <span className="font-bold">
                    For back sleepers: Medium-firm
                  </span>{" "}
                  mattresses are generally preferred for balanced support and
                  comfort.
                </li>
                <li>
                  {" "}
                  <span className="font-bold">
                    For side sleepers: Soft to medium-firm
                  </span>{" "}
                  mattresses are typically recommended to provide pressure
                  relief and comfortable body alignment.
                </li>
                <li>
                  {" "}
                  <span className="font-bold">
                    For front (stomach) sleepers: Medium to firm{" "}
                  </span>{" "}
                  mattresses are generally preferred for better body
                  support{" "}
                </li>
                <li>
                  {" "}
                  <span className="font-bold">
                    For children: Soft and supportive comfort options{" "}
                  </span>{" "}
                  are commonly recommended, with Latex comfort layers as a
                  consideration.
                </li>
                <li>
                  {" "}
                  <span className="font-bold">
                    For elderly people: Firm mattresses{" "}
                  </span>{" "}
                  are generally preferred to provide supportive comfort and ease
                  of movement.{" "}
                </li>
              </ul>
              <p className="pt-1">
                Since every sleeper’s needs are different, Moondew
                recommendations can also be personalized to match individual
                comfort and sleep preferences.
              </p>
            </div>
          </div>
        </div>
        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(11)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              11
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                How do I choose between a firm and a hard mattress, and does
                Moondew offer customizable comfort options?
              </span>
              <span className="text-2xl">
                {openIndex === 11 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 11
                ? "md:max-h-60 max-h-96 opacity-100"
                : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                The ideal mattress depends on{" "}
                <span className="font-bold">
                  individual comfort preferences and support requirements. Firm
                  mattresses
                </span>{" "}
                generally provide balanced support and are commonly preferred
                for overall comfort, while{" "}
                <span className="font-bold">harder comfort surfaces</span> may
                suit specific sleeping preferences or support needs.
              </p>
              <p className="pt-1">
                Yes.{" "}
                <span className="font-bold">
                  Customization is one of Moondew’s specialties
                </span>{" "}
                , allowing customers to personalize mattress comfort
                levels—including different firmness preferences—to match their
                individual requirements.
              </p>
            </div>
          </div>
        </div>

        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(12)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              12
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                What cover options are available for Moondew mattresses, and can
                they vary across collections?
              </span>
              <span className="text-2xl">
                {openIndex === 12 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 12 ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew offers a curated range of{" "}
                <span className="font-bold">
                  premium mattress cover fabrics
                </span>{" "}
                designed to enhance comfort, breathability, and overall sleep
                experience. Available options include:
              </p>
              <ul className="list-disc ps-6 pt-1">
                <li>
                  {" "}
                  <span className="font-bold">Organic cotton</span>{" "}
                </li>
                <li>
                  {" "}
                  <span className="font-bold">Linen</span>{" "}
                </li>
                <li>
                  {" "}
                  <span className="font-bold">Jute–cotton blends</span>{" "}
                </li>
                <li>
                  {" "}
                  <span className="font-bold">Cooling fabrics</span>{" "}
                </li>
                <li>
                  {" "}
                  <span className="font-bold">
                    Other premium textiles,{" "}
                  </span>{" "}
                </li>
              </ul>
              <p className="pt-1">
                Yes.{" "}
                <span className="font-bold">
                  Cover and fabric options vary across different mattress
                  collections
                </span>{" "}
                , and customization is also available to align with individual
                preferences and requirements
              </p>
            </div>
          </div>
        </div>

        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(13)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              13
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                Do you have an expert to guide me on my choice of a Moondew
                mattress?
              </span>
              <span className="text-2xl">
                {openIndex === 13 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 13 ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Yes, we have experts available to assist you in choosing the
                right Moondew mattress for your needs.
              </p>
            </div>
          </div>
        </div>

        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(14)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              14
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                Is Moondew available in stores as well?
              </span>
              <span className="text-2xl">
                {openIndex === 14 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 14 ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Moondew currently focuses on experience centres that offer
                guided product discovery and personalized consultation. Please
                visit our website for location details.{" "}
              </p>
            </div>
          </div>
        </div>

        <div className="border-b border-[#b1b1b1] overflow-hidden">
          <button
            onClick={() => toggleFAQ(15)}
            className="w-full flex items-center md:px-5 py-3 sm:gap-3 gap-6 lg:gap-12 text-left md:font-semibold font-medium transition"
          >
            <span className="flex flex-shrink-0 justify-center items-center md:w-10 md:h-10 h-8 w-8 rounded-full border text-base md:text-xl font-medium font-lexend text-[#3a683f] border-[#3a683f]">
              15
            </span>
            <div className="flex justify-between items-center w-full">
              <span className="md:text-xl text-base text-[#3a683f] md:font-semibold font-medium font-lexend">
                Does Moondew roll-pack mattresses for delivery?
              </span>
              <span className="text-2xl">
                {openIndex === 15 ? (
                  <KeyboardArrowUpIcon className="text-[#3a683f]" />
                ) : (
                  <KeyboardArrowDownIcon className="text-[#3a683f]" />
                )}
              </span>
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out flex flex-row items-center gap-6 lg:gap-12 overflow-hidden ${
              openIndex === 15 ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <span className="md:flex hidden justify-center items-center w-10 h-10 rounded-full font-medium font-lexend "></span>{" "}
            <div className="sm:px-3 px-5 pb-5 sm:text-sm text-base text-[#3a683f] font-lexend font-light lg:w-3/4">
              <p>
                Currently, Moondew follows a non-compression delivery approach
                to maintain product integrity and preserve comfort performance.
                Sustainable packaging alternatives are also being explored for
                local deliveries.
              </p>
            </div>
          </div>
        </div>
        <div className="w-full xl:h-48 lg:h-40 md:h-28 h-20 xs:h-16"></div>
      </div>
    </div>
  );
};

export default FaqPage;
